import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-community',
  templateUrl: './community.component.svg',
})
export class CommunityComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
